import React, { useContext } from "react";

import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../store/rootStore";
import { ICoCurricularCard } from "../models/cocurricular";



const CoCurricularCardDetail:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);
  const {ccCardChosen} : {ccCardChosen: ICoCurricularCard} = rootStore.coCurricularStore;


  return (
    <div className={`card__detail card__detail_1`}>
      {ccCardChosen.coCurricular.image !== null ?
        <div className='card__detail-cc-background-image' style={{backgroundImage: `url(${ccCardChosen.coCurricular.image.mediaItemUrl})`}}></div>
        : null
      }
      <div className='card__detail-body'>
        <h1>{ccCardChosen.title}</h1>
        <div className='card__card-times'  dangerouslySetInnerHTML={{__html: ccCardChosen.coCurricular.time}}></div>
        <div className='card__card-venue'>Venue: {ccCardChosen.coCurricular.venue}</div>
        <div className='card__card-forms'>Open to:  {ccCardChosen.coCurricular.form.nodes.length === 13 ? 'all' :
          ccCardChosen.coCurricular.form.nodes.map(form => (
            <span>{form.name}</span>
          ))
        }</div>

        {
          ccCardChosen.content != null
            ? <>
                <div className='card__detail-content' dangerouslySetInnerHTML={{__html: ccCardChosen.content}} />
              </>
            : null
        }

        {/* <div className='buttons'>
          <button>Apply now</button>
        </div>  */}

      </div>
        
    </div>
  )
});

export default CoCurricularCardDetail;
